/**
 * @typedef {Object} ClickActionComponentProps
 *
 * @property {boolean} disabled
 * @property {React.MouseEventHandler} onClick
 */

/**
 * @typedef {TProps} ClickActionProps
 * @template {ClickActionComponentProps} TProps
 * @template {*} TValue
 *
 * @property {React.ComponentType<TProps>} Component
 * @property {boolean} disabled
 * @property {TValue} value
 * @property {(value: TValue) => void} [onAction]
 * @property {(event: React.MouseEvent) => void} [onClick]
 */

/**
 * The {@link ClickAction} component is used to render a button-like component
 * that calls `onAction` handler each time it is clicked on.
 *
 * @template {ClickActionComponentProps} TProps
 * @template {*} TValue
 *
 * @param {ClickActionProps<TProps, TValue>} props
 */
function ClickAction({
  Component,
  disabled,
  value,
  onAction,
  onClick,
  ...componentProps
}) {
  /** @param {React.MouseEvent} event */
  function handleClick(event) {
    if (!disabled) {
      onAction?.(value)
    }

    onClick?.(event)
  }

  return (
    <Component
      {...componentProps}
      disabled={disabled}
      value={value}
      onClick={handleClick}
    />
  )
}

export default ClickAction
